import { gsap } from "../gsap/all.js";
import { ScrollTrigger } from "../gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);
gsap.config({nullTargetWarn:false});
export default {

  init() {

    $(function() {
      $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').on('click', function(e) {
          if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
              e.preventDefault();
              $('html, body').animate({
                  scrollTop: $($(this).attr('href')).offset().top,
              }, 500, 'linear');
          }
      });
  });

  //Blog
  $(document).on('click', '.load-more', function(e) {
    e.preventDefault();
  
    var id = $(this).attr('data-section'),
    postType = $(this).attr('data-post-type'),
    contains = $(this).attr('data-contains'),
    tag = $(this).attr('data-tag'),
    current = parseInt($(this).attr('data-current'), 10),
    max = $(this).attr('data-max');
  
    console.log(id);
  
    $('.load-more').attr('data-contains', contains);
    $('.load-more').attr('data-tag', tag);
    $('#' + id + ' .load-more').hide();
    $('#' + id + ' .pagination-count svg').show();
    $('#' + id + ' .pagination-count .no-posts').hide();
  
    $.ajax({
      url: ajaxurl + '?action=loadMorePosts',
      type: 'post',
      data: {
        section: id,
        postType: postType,
        contains: contains,
        tag: tag,
        current: current,
      },
      success: function(data) {
        var dataArray = JSON.parse(data),
        current = parseInt(dataArray['current'], 10),
        id = dataArray['id'];
                var max = parseInt(dataArray['max'], 10); // Ensure max is correctly updated from response
  
                console.log(id);
  
                $('#' + id + ' .current-page').html(current);
                $('.load-more').attr('data-current', current);
                $('.load-more').attr('data-max', max); // Update the max value
                $('#' + id + ' .pf-filter-list').append(dataArray['html']); // Append to the existing row
                setTimeout(function() {
                  AOS.refresh();
                }, 200);
                setTimeout(function() {
                  $('#' + id + ' .pf-post-card:not(.aos-animate)').addClass('aos-animate');
                }, 400);
  
                $('#' + id + ' .pagination-count svg').hide();
                if (current >= max) {
                  $('#' + id + ' .pagination-count .no-posts').show();
                } else {
                  $('#' + id + ' .load-more').show();
                }
              },
              error: function(jqXHR, textStatus, errorThrown) {
                console.log(jqXHR);
                console.log(textStatus);
                console.log(errorThrown);
              },
            });
  });

   //News Media
   $(document).on('click', '.load-more-media', function(e) {
    e.preventDefault();

    var id = $(this).attr('data-section'),
    postType = $(this).attr('data-post-type'),
    contains = $(this).attr('data-contains'),
    tag = $(this).attr('data-tag'),
    current = parseInt($(this).attr('data-current'), 10),
    max = $(this).attr('data-max');

    console.log(id);

    $('.load-more-media').attr('data-contains', contains);
    $('.load-more-media').attr('data-tag', tag);
    $('#' + id + ' .load-more-media').hide();
    $('#' + id + ' .pagination-count-media svg').show();
    $('#' + id + ' .pagination-count-media .no-posts').hide();

    $.ajax({
      url: ajaxurl + '?action=loadMorePostsMedia',
      type: 'post',
      data: {
        section: id,
        postType: postType,
        contains: contains,
        tag: tag,
        current: current,
      },
      success: function(data) {
        var dataArray = JSON.parse(data),
        current = parseInt(dataArray['current'], 10),
        id = dataArray['id'];
            var max = parseInt(dataArray['max'], 10); // Ensure max is correctly updated from response

            console.log(id);

            $('#' + id + ' .current-page').html(current);
            $('.load-more-media').attr('data-current', current);
            $('.load-more-media').attr('data-max', max); // Update the max value
            $('#' + id + ' .pf-filter-list-media').append(dataArray['html']); // Append to the existing row
            setTimeout(function() {
              AOS.refresh();
            }, 200);
            setTimeout(function() {
              $('#' + id + ' .pf-post-card:not(.aos-animate)').addClass('aos-animate');
            }, 400);

            $('#' + id + ' .pagination-count-media svg').hide();
            if (current >= max) {
              $('#' + id + ' .pagination-count-media .no-posts').show();
            } else {
              $('#' + id + ' .load-more-media').show();
            }
          },
          error: function(jqXHR, textStatus, errorThrown) {
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
          },
        });
  });

    // Nav Animation

    let pstl = gsap.timeline({
      scrollTrigger: {
        trigger: '.marker',
        scrub: true,
        start:"top 50px",
      },
    });
    pstl.to('.nav-wrap', { backgroundColor: 'rgba(0, 3, 26, 0.9)', duration: 0.5 })

    $('.smooth, .smooth a').click(function() {
      if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
        $('.top-bar').removeClass('open');
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html,body').animate({scrollTop: target.offset().top - 90}, 1000); // Set scroll speed here
          return false;
        }
      }
    });

    if ($('.expanding-image-list').length !== -1) {
      var eil = false;
      $(document).on('mouseenter', '.expanding-image-list > .columns:not(.expanded)', function(e) {
        if (eil == false) {
          eil = true;
          window.setTimeout(function () { eil = false }, 400);
          $(this).parent().find('.expanded').removeClass('expanded');
          $(this).addClass('expanded');
        }
      });
    }

    $('.no-link a').on('click', function(event) {
      event.preventDefault();
    });

    // Nav/Hamburger

    $('.hamburger').on('click', function() {
      $(this).toggleClass('is-active');
      $('.top-bar').toggleClass('open');
      $('html').toggleClass('overflow');
      $('.mega-menu').removeClass('show');
    });

    $('.bank-wrap').on('click', function() {
      $(this).next().children('.link-bank').toggleClass('show');
    });

    $('.has-children a').on('mouseenter', function() {
      $(this).parent().children('.mega-menu').addClass('show');
      $(this).parent().siblings().children('.mega-menu').removeClass('show');
      $(this).parent().addClass('active');
      $(this).parent().siblings().removeClass('active');
    });

    $('.mega-menu').on('mouseleave', function() {
      $(this).parent().children('.mega-menu').removeClass('show');
      $(this).parent().siblings().children('.mega-menu').removeClass('show');
      $(this).parent().removeClass('active');
      $(this).parent().siblings().removeClass('active');
    });

    $('.wrap.container').on('click', function() {
      $('.mega-menu').removeClass('show');
      $('.has-children').removeClass('active');
    });

    // END Nav/Hamburger

    $('.tabs-title .txt-link').on('click', function() {
      window.location.href = $(this).attr('href');
    });

    $('.mq-slide').slick({
      arrows: false,
      dots: false,
    });

    $('.video-slider').slick({
      arrows: false,
      dots: true,
    });

    $('.video-title:first').addClass('highlight');

    $('.video-slider').on('afterChange', function(event, slick, currentSlide) {
      $('.video-title').removeClass('highlight');
      $('.video-title-' + currentSlide).addClass('highlight');
    });

    $('.case-study-slider').slick({
      arrows: false,
      dots: true,
      centerMode: false,
    });

    $('.stack-slider').slick({
      arrows: false,
      dots: true,
    });

    $('.product-card-slider').slick({
      arrows: false,
      dots: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      ],
    });

    $('.logo-slider-condensed').slick({
      dots: false,
      arrows: false,
      slidesToShow: 6,
      slidesToScroll: 3,
      autoplay: true,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      ],
    });

    $('.buckets-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoPlaySpeed: 30000,
      infinite: true,
      centerMode: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          },
        },
      ],
    });

    $('.culture-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoPlaySpeed: 30000,
      infinite: true,
      //centerMode: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    $('.diversity-slider').slick({
      arrows: false,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoPlaySpeed: 30000,
      infinite: true,
      centerMode: false,
    });

    $('.quote-slider-full').slick({
      prevArrow: '<button type="submit" class="slick-prev" aria-label="next quote"><svg xmlns="http://www.w3.org/2000/svg" width="41.778" height="36.04" viewBox="0 0 41.778 36.04"><path id="Path_6120" data-name="Path 6120" d="M22.842,0,19.124,3.968,31.332,15.407H0v5.438H31.107L19.124,32.073l3.718,3.967L41.778,18.3l-.26-.277.26-.277Z" transform="translate(41.778 36.04) rotate(180)" fill="rgba(255,255,255,0.34)"/></svg></button>',
      nextArrow: '<button type="submit" class="slick-next" aria-label="previous quote"><svg xmlns="http://www.w3.org/2000/svg" width="41.778" height="36.04" viewBox="0 0 41.778 36.04"><path d="M22.842,0,19.125,3.968,31.332,15.407H0v5.438H31.108L19.125,32.073l3.718,3.967L41.778,18.3l-.26-.277.26-.277Z" transform="translate(0)" fill="rgba(255,255,255,0.34)"/></svg></button>',
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
    });

    $('.logo-slider').slick({
      dots: false,
      arrows: true,
      prevArrow: '<button type="submit" class="slick-prev"><i class="far fa-arrow-left"></i></button>',
      nextArrow: '<button type="submit" class="slick-next"><i class="far fa-arrow-right"></i></button',
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          arrows: true,
          dots: false,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        },
      },
      ],
    });

    $('.sm-list').slick({
      arrows: false,
      dots: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
      ],
    });

    $(document).on('click', '.fdl-item__title', function(e) {
      $(this).toggleClass('open');
    });

    // $('.accordion-title-in').on('click', function(event) {
    //   $(this).next().fadeToggle();
    //   $(this).parent().siblings().children('.accordion-content-inner').hide();
    //   event.preventDefault();
    // });

    // $('.accordion-content-inner').first().css('display', 'block');
    // $('.accordion-title-in').first().addClass('open');

    // $('.accordion-title-in').on('click', function(event) {
    //   $(this).next().fadeToggle();
    //   $(this).toggleClass('open');
    //   $(this).parent().siblings().children('.accordion-content-inner').not($(this).next()).hide();
    //   $(this).parent().siblings().find('.accordion-title-in').removeClass('open');
    //   event.preventDefault();
    // });

  $('.accordion-content-inner').first().css('display', 'block');
  $('.accordion-title-in').first().addClass('open');

  $('.accordion-title-in').on('click', function(event) {
    if (!$(this).hasClass('open')) {
      $('.accordion-title-in.open').removeClass('open');
      $('.accordion-content-inner').hide();

      // Open the clicked accordion
      $(this).next().fadeIn();
      $(this).addClass('open');
    }

    event.preventDefault();
  });

    var quoteSlider = $(".quote-slider-full");

    $(window).on("scroll", function() {
      var windowHeight = $(window).height();
      var scrollTop = $(window).scrollTop();
      var sectionOffset = quoteSlider.offset().top;

  if ($('body').hasClass('home')) {
    if (scrollTop + windowHeight >= sectionOffset) {
      quoteSlider.addClass("animate-quotes");
    } else {
      quoteSlider.removeClass("animate-quotes");
    }
  }

  if ($('body').hasClass('solutions-payers')) {
    if (scrollTop + windowHeight >= sectionOffset) {
    quoteSlider.addClass("animate-quotes");
    } else {
      quoteSlider.removeClass("animate-quotes");
    }
  }

  if ($('body').hasClass('careers')) {
    if (scrollTop + windowHeight >= sectionOffset) {
    quoteSlider.addClass("animate-quotes");
    } else {
      quoteSlider.removeClass("animate-quotes");
    }
  }
  });

    const animVideo = gsap.utils.toArray('.animation-video')

    animVideo.forEach(function(video, i) {

      ScrollTrigger.create({
        trigger: video,
        scroller: '.media-area',
        start: 'top center',
        end: 'bottom center',
        onEnter: () => video.play(),
        onEnterBack: () => video.play(),
        onLeave: () => video.pause(),
        onLeaveBack: () => video.pause(),
      });

    })

    if ($('body').hasClass('careers')) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.get('gh_jid')) {
        $('html, body').animate({'scrollTop': $('#content-job-postings').offset().top }, 1000);
        console.log('hi');
      }
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js